import { Routes, Route } from 'react-router';
import Guidelines from 'pages/Guidelines';

const GuidelinesLayout = () => (
  <Routes>
    <Route index element={<Guidelines />} />
  </Routes>
);

export default GuidelinesLayout;
